export default class Auth {
  constructor(firebase) {
    this.firebase = firebase
  }
}
